// pages/Dashboard.jsx
import DashboardLayout from "../../components/dashboard/DashboardLayout";
import AllUsers from "../../components/dashboard/AllUsers";

export default function Dashboard() {
  return (
    <DashboardLayout>
      <AllUsers />
    </DashboardLayout>
  );
}
